<!-- @format -->
@if (
	((shipMode$ | async) === 'bopis' || (shipMode$ | async) === 'bopl') &&
	inStorePickupButtonText$ | async; as inStorePickupButtonText
) {
	<div id="pdp-in-store-pickup-subtext">

		<div
			class="hmf-flex-row hmf-align-items-flex-start hmf-mb-xxxs hmf-mb-m-xxs"
			[ngClass]="
				inStorePickupButtonText.fulfillmentButtonDisabledClass
					? 'label-base-subtle'
					: 'label-base'
			"
		>
			@if (inStorePickupButtonText.fulfillmentLabelTextLine1) {
				<div
					class="ff-label-text-1 hmf-mr-xxs hmf-body-m hmf-body-m-l">
					{{ inStorePickupButtonText.fulfillmentLabelTextLine1 }}
				</div>
			}
			@if (inStorePickupButtonText.fulfillmentLabelTextLine1) {
				<div>
					<span>
						<pdp-feature-change-store-button
							[productSkusPartNumber]="productSkusPartNumber$ | async"
							[resolvedSkuId]="resolvedSkuId$ | async"
							[isSubtext]="true"
							[isDisabled]="inStorePickupButtonText.fulfillmentButtonDisabledClass"
							[dataEm]="isBundle ? undefined : 'PDP_changeStore_bopisLink'">
							{{ selectCrossChainBopisStoreName$ | async }}
							{{ selectStoreNameTitleCase$ | async }}
						</pdp-feature-change-store-button>
					</span>
				</div>
			}
		</div>

		@if (inStorePickupButtonText.lowStockMessage && !inStorePickupButtonText.availableInStoreOnly) {
			<div
				id="pdp-in-store-pickup-low-stock"
				class="hmf-mb-xxs hmf-mb-m-xxs hmf-body-bold-m label-warning">
				{{ inStorePickupButtonText.lowStockMessage }}
			</div>
		}

		@if (inStorePickupButtonText.availableInStoreOnly) {
			<div class="hmf-mb-m-xxs hmf-mb-xxxs hmf-body-s">
				@if (inStorePickupButtonText.lowStockMessage) {
					<span class="hmf-mb-m-xxs hmf-mb-xxxs hmf-body-bold-s label-warning">
						{{ inStorePickupButtonText.lowStockMessage }}
					</span>
				}
				Available for <span class="hmf-body-bold-s">in store purchase only</span>
			</div>
		}

		@if (inStorePickupButtonText.fulfillmentLabelTextLine2) {
			<div
				id="pdp-in-store-pickup-line2"
				class="hmf-body-m hmf-mb-xxs gray700">
				{{ inStorePickupButtonText.fulfillmentLabelTextLine2 }}
			</div>
		}

		@if (inStorePickupButtonText.storeClosedMessage) {
			<div
				id="pdp-in-store-temporarily-closed"
				class="hmf-mb-m-xxs hmf-mb-xxxs label-negative">
				{{ inStorePickupButtonText.storeClosedMessage }}
			</div>
		}

		@if (
			inStorePickupButtonText.buttonAction !== 'SelectOptions' &&
			(selectNearbyAvailableStores$ | async) !== undefined &&
			(selectStoreNameTitleCase$ | async)
		) {
			<div
				id="pdp-in-store-pickup-not-available"
				class="hmf-mb-l hmf-mb-m-xxs">
				@if ((selectNearbyAvailableStores$ | async) > 0) {
					<span class="hmf-body-s hmf-body-m-m">
						{{
							inStorePickupButtonText.notAvailable ? 'Available at' : 'Also available at'
						}}
						<span class="hmf-body-bold-s hmf-body-bold-m-m">
							{{ selectNearbyAvailableStores$ | async }}
						</span>
					</span>
					<span class="hmf-body-s hmf-body-m-m"> nearby stores</span>
				}
				@if ((selectNearbyAvailableStores$ | async) === 0) {
					<span class="hmf-body-s hmf-body-m-m label-base-subtle">
						Not available at stores within 100 miles
					</span>
				}
			</div>
		}
	</div>
}
